









































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import CustomFieldsMixin from "@/mixins/customFieldsMixin";
import TagsMixin from "@/mixins/tagsMixin";
import MultilevelCategoriesFetcher from "@/components/app/admin/catalogue/products/multilevelCategories/multilevelCategoriesFetchMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import {
  orderFilters,
  orderItemsFilters,
  orderClientsFilters
} from "@/data/filters/order";
import orderSorters from "@/data/sorters/order";
import { Sorters } from "@/data/table";
import { CustomFieldsMajorTypes } from "@/data/enums/customFields";

// Types
import { ITableConfig, IFilter, ISorter } from "@/models/tables";
import { IPromotion } from "@/models/promotions";

@Component({
  components: {
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  }
})
export default class PromotionUsesTable extends Mixins(
  FilteringSortingTableStore,
  CustomFieldsMixin,
  TagsMixin,
  MultilevelCategoriesFetcher
) {
  @Prop({ required: true })
  public promotionId!: IPromotion["id"];

  // Data
  public dataModule: DataModules = DataModules.ORDERS;
  public isLoading = false;
  public isReloading = false;
  public requestError = false;

  public filters: IFilter[] = [];
  public sorters: ISorter[] = orderSorters();

  public defaults: ITableConfig = {
    sort: {
      field: "id",
      direction: Sorters.DESCENDING
    }
  };

  public async created() {
    if (!this.contentIsAvailable) {
      return;
    }
    this.apiProps = {
      "filter[promotions.promotion_id]": this.promotionId,
      with: ["client", "promotions", "client.image", "status", "products"].join(
        ","
      )
    };

    this.isLoading = true;
    this.loading = true;
    this.loadData();
  }

  public async loadData() {
    try {
      await Promise.all([
        this.getClientCustomFields(this.isReloading),
        this.getBasketCustomFields(this.isReloading),
        this.getTags(this.isReloading),
        this.getRootCategories(this.isReloading)
      ]);

      this.setFilters();
      this.getData();
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    }

    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public setFilters() {
    this.filters = this.$_.concat(
      orderFilters(),
      this.customFieldsFilters(
        CustomFieldsMajorTypes.BASKET,
        "",
        "order_custom_fields"
      ),
      this.getProductCategoryFilledFilters(orderItemsFilters(), false),
      [
        this.createTagFilter(
          "products.tags.id",
          this.$t("_.order_item_tag").toString(),
          "order_item"
        )
      ],
      orderClientsFilters(),
      [
        this.createTagFilter(
          "client.tags.id",
          this.$t("_.client_tag"),
          "client"
        )
      ],
      this.customFieldsFilters(
        CustomFieldsMajorTypes.CLIENT,
        "client",
        "client_custom_fields"
      )
    );
  }

  public guardFunctionalities = ["staff_list_orders"];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
